import React from 'react';

import { Member } from '../../types/Member';
import FieldView from '../utils/FieldView';

type Props = {
  attendees: Member[];
  allMembers?: unknown[];
};
export default ({ attendees = [], allMembers }: Props) => (
  <FieldView name='Attendees' md={2} vmd={4}>
    {allMembers && (
      <div style={{ fontWeight: '600' }}>
        {attendees.length}/{allMembers.length}party members:
      </div>
    )}
    {attendees.map(member => (
      <div key={member.memberId} className='row memb-descr'>
        {member.memberName}
      </div>
    ))}
  </FieldView>
);
